import { getApiUrl } from "../config";
import { ORG_ID } from "../constant/constant";
import { get, post, deletes } from "./axiosRequest";

export const getCredentialReport = async ({ data }) => {
  const { groupId } = data;
  const url = `${
    getApiUrl().adminApiUrl
  }/Credential/GeCredentialReports?orgId=${ORG_ID()}&groupId=${groupId}`;

  try {
    return await get(url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (err) {
    return err;
  }
};

export const getLookupCredentialReport = async ({ data }) => {
  const {
    tabId,
    startDate,
    endDate,
    page,
    pageSize,
    groupId,
    divisionId = 0,
    isSendMail = false,
  } = data;

  const url = `${
    getApiUrl().adminApiUrl
  }/Credential/GetConfigureCredentialListReports?orgId=${ORG_ID()}&divisionId=${divisionId}&tabId=${tabId}&startDate=${startDate}&endDate=${endDate}&page=${page}&pageSize=${pageSize}&groupId=${groupId}&isSendMail=${
    isSendMail ? isSendMail : false
  }`;

  try {
    return await get(url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (err) {
    return err;
  }
};

export const getConfiguredCredentialReport = async ({ data }) => {
  const {
    tabId,
    startDate,
    endDate,
    page,
    pageSize,
    groupId,
    userId,
    divisionId = 0,
  } = data;

  const url = `${
    getApiUrl().adminApiUrl
  }/Credential/GetConfigureCredentialListReports?orgId=${ORG_ID()}&divisionId=${divisionId}&userId=${userId}&tabId=${tabId}&startDate=${startDate}&endDate=${endDate}&page=${page}&pageSize=${pageSize}&groupId=${groupId}`;

  try {
    return await get(url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (err) {
    return err;
  }
};
